// extracted by mini-css-extract-plugin
module.exports = {"app":"styles_app__1aTJl","header":"styles_header__3q8Zo","score":"styles_score__2sd9f"};